import React, { useEffect } from 'react';
import { Modal, Icon, Tooltip, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBookmark, clearBookmark, fetchBookmarkFilters } from 'app/actions/BookmarkActions';
import { getBookmark, getIsLoadingBookmark, getBookmarkFilters } from 'app/reducers';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import { setTimeout } from 'timers';
import isEmpty from 'app/utils/IsEmpty';
import moment from 'moment';
import { isNullOrUndefined } from 'util';


export default function BookmarkTableContainer(props) {
    const { idSubdirection } = useSelector(state => state.Auth.employeeById);
    const { classes } = props;
    const { confirm } = Modal;
    const pagination = props.pagination;
    const sorter = props.sorter;
    const { siteId } = useSelector(state => state.Auth)
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;
    const columns = [
        {
            title: 'Estatus',
            dataIndex: 'status',
            key: 'status',
            sorter: false,
            align: 'center',
            width: 100,
            render: (text, record) => (

                text === 1 ?
                    <Tooltip placement="bottom" title="Pendiente">
                        <Icon type="clock-circle" theme="twoTone" twoToneColor="#ffbb80"  style={{ fontSize: '1.5em' }} />
                    </Tooltip>
                    : (
                        text === 2 ?
                            <Tooltip placement="bottom" title="Progreso">
                                <Icon type="info-circle" theme="twoTone" twoToneColor="#fff875" style={{ fontSize: '1.5em' }} />
                            </Tooltip>
                            :
                            <Tooltip placement="bottom" title="Completado">
                                <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" style={{ fontSize: '1.5em' }} />
                            </Tooltip>
                    )
            )
        },
        {
            title: 'Folio',
            dataIndex: 'bookmarkFolio',
            key: 'bookmarkFolio',
            sorter: true,
            width: 150
        },
        {
            title: 'Nombre',
            dataIndex: 'bookmarkName',
            key: 'bookmarkName',
            sorter: true,
            width: 300,
            ellipsis: true

        },
        {
            title: 'Fecha de creación',
            dataIndex: 'bookmarkCreationDate',
            key: 'bookmarkCreationDate',
            sorter: true,
            width: 170,
            render: (bookmarkCreationDate) => {
                return moment(bookmarkCreationDate).locale('es').format('L')
            }
        },
        {
            title: 'Fecha de inicio',
            dataIndex: 'bookmarkStartDate',
            key: 'bookmarkStartDate',
            sorter: true,
            width: 170,
            render: (bookmarkStartDate) => {
                return moment(bookmarkStartDate).locale('es').format('L')
            }
        },
        {
            title: 'Fecha de fin',
            dataIndex: 'bookmarkEndDate',
            key: 'bookmarkEndDate',
            sorter: true,
            width: 170,
            render: (bookmarkEndDate) => {
                return moment(bookmarkEndDate).locale('es').format('L')
            }
        },
        {
            title: 'Creado por',
            dataIndex: 'employeeName',
            key: 'employeeName',
            sorter: true,
            width: 300
        },
        {
            width: '100%'
        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idBookMark',
            fixed: 'right',
            render: (text, record) => (
                !isNullOrUndefined(record.bookmarkDirectory) ?
                    (
                        <div className={classes.buttons}>

                            <Tooltip placement="bottom" title={'Eliminar'}>
                                <IconButton className={classes.deleteIcon} onClick={() => showConfirmDelete(record)}>
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip>

                            <Tooltip placement="bottom" title={'Visualizar'}>
                                <IconButton className={classes.editIcon} onClick={() => showDrawer(record)}>
                                    <Icon type="file-pdf" />
                                </IconButton>
                            </Tooltip>

                            <Tooltip placement="bottom" title={'Exportar'}>
                                <IconButton className={classes.editIcon} onClick={() => downloadFile(record.bookmarkUrl, `${record.bookmarkName}`)}>
                                    <Icon type="download" />
                                </IconButton>
                            </Tooltip>
                        </div>
                    ) :
                    (
                        <div className={classes.buttons}>
                            <Tooltip placement="bottom" title={'Eliminar'}>
                                <IconButton className={classes.deleteIcon} onClick={() => showConfirmDelete(record)}>
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip>
                        </div>
                    )

            )
        }
    ];

    const showDrawer = (data) => {
        props.setPDFData(data)
        props.setVisiblePDF(true)
    }
    const downloadFile = (url, fileName) => {
        let link = document.createElement('a');
        link.href = url;
        link.target = '_blank'
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
    };

    const showConfirmDelete = (param) => {
        confirm({
            title: '¿Eliminar Bookmark?',
            content: param.bookmarkName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                return deleteBookmark(String(param.idBookMark));
            },
            onCancel() { },
        });

    }

    async function deleteBookmark(id) {
        await ApiService.deleteBookmark(id).then(res => {
            dispatch(clearBookmark());
            fetchBookmarkAction();
            message.success(`El bookmark se eliminó correctamente!`);
        });
    }

    let bookmarks = useSelector(getBookmark);
    let bookmarksFilters = useSelector(getBookmarkFilters);

    let isLoading = useSelector(getIsLoadingBookmark);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(bookmarks)) fetchBookmarkAction();
        if (isEmpty(bookmarksFilters)) fetchBookmarkFiltersAction();
    }, []);


    const handleTableChange = (pagination, filters, sorter) => {

        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }

        dispatch(fetchBookmark(
            {
                Subdirection: (typeof props.formData.Subdirection === "undefined") ? '3' : props.formData.Subdirection,
                Contract: (typeof props.formData.Contract === "undefined") ? '' : props.formData.Contract,
                Work: (typeof props.formData.Work === "undefined") ? '' : props.formData.Work,
                CommunicationProgram: (typeof props.formData.CommunicationProgram === "undefined") ? '' : props.formData.CommunicationProgram,
                Front: (typeof props.formData.Front === "undefined") ? '' : props.formData.Front,
                BookMarkFolio: (typeof props.formData.BookMarkFolio === "undefined") ? '' : props.formData.BookMarkFolio,
                EmployeeId: (typeof props.formData.EmployeeId === "undefined") ? '' : props.formData.EmployeeId,
                StartDateCreation: (typeof props.formData.StartDateCreation === "undefined") ? '' : props.formData.StartDateCreation,
                EndDateCreation: (typeof props.formData.EndDateCreation === "undefined") ? '' : props.formData.EndDateCreation,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }));
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && bookmarks.length > 0) {
            pagination.total = bookmarks[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter !== null) {
        column = sorter.field === undefined ? '' : sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }

    const fetchBookmarkAction = () => dispatch(fetchBookmark({
        Subdirection: '3',
        sortColumn: column,
        sortDir: order, offset: offset, limit: limit
    }));
    const fetchBookmarkFiltersAction = () => dispatch(fetchBookmarkFilters({ idSubdirection: idSubdirection }));
    
    return (props.children({ pagination: pagination, cols: columns, bookmarks, bookmarksFilters, isLoading, handleTableChange: handleTableChange }));
}